/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Agent lifecycle status (Ghost Identity) */
export enum AgentStatus {
  Unregistered,
  Registered,
  Claimed,
  Verified,
}

export type AgentStatusArgs = AgentStatus;

export function getAgentStatusEncoder(): FixedSizeEncoder<AgentStatusArgs> {
  return getEnumEncoder(AgentStatus);
}

export function getAgentStatusDecoder(): FixedSizeDecoder<AgentStatus> {
  return getEnumDecoder(AgentStatus);
}

export function getAgentStatusCodec(): FixedSizeCodec<
  AgentStatusArgs,
  AgentStatus
> {
  return combineCodec(getAgentStatusEncoder(), getAgentStatusDecoder());
}
